export default {
    getDisplayDate: (date) => {
        if(!(date instanceof Date)) {
            date = new Date(date);
        }
        var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

        return date.toLocaleDateString("en-US", options)
    },
    getDisplayTime: (date) => {
        if(!(date instanceof Date)) {
            date = new Date(date);
        }

        return date.toLocaleTimeString("en-US")
    },
    getDisplayDateTime: (date) => {
        if(!(date instanceof Date)) {
            date = new Date(date);
        }
        var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

        return `${date.toLocaleDateString("en-US", options)} ${date.toLocaleTimeString("en-US")}`
    }
}